import request from '@/utils/request'


/* 客户还车相关接口 start */
// 客户还车-列表页查询接口
export function getReturnCarOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/list',
    method: 'POST',
    data,
  })
}

// 客户还车-列表页状态统计接口
export function getReturnCarStatistics(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/statistics',
    method: 'POST',
    data,
  })
}

// 客户还车-个人客户发起还车
export function submitPersonalReturnCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/start',
    method: 'POST',
    data,
  })
}

// 客户还车-企业客户发起还车
export function submitEnterpriseReturnCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/ent/start',
    method: 'POST',
    data,
  })
}

// 取消退车
export function cancelReturnCar(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/cancel',
    method: 'POST',
    data,
  })
}

// 上传文件
export function uploadFile(data = {}) {
  return request({
    url: '/admin/v1/vehicle/fs/standard/upload',
    method: 'POST',
    data,
  })
}

// 根据任务ID查询任务详情
export function getUploadTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/detail',
    method: 'POST',
    data,
  })
}

// 根据车牌号或客户姓名查询订单
export function getRentOrderId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/getRentOrderId',
    method: 'POST',
    data,
  })
}

// 退车订单列表(包含退车类型)
export function getOrderLeaseList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/return/lease/order/search',
    method: 'POST',
    data,
  })
}

// 获取订单详情，包括：个人订单、企业子订单
export function getOrderDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/detail',
    method: 'POST',
    data,
  })
}

// 获取退车单详情
export function getReturnCarOrderDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/detail',
    method: 'POST',
    data,
  })
}

// 出入库详情
export function getOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/details',
    method: 'POST',
    data,
  })
}
// 获取出入库详情提交确认未捕获到的部分信息
export function getTempOutInDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/getStockInfo',
    method: 'POST',
    data,
  })
}

// 编辑出入库记录
export function editOutIn(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/update',
    method: 'POST',
    data,
  })
}
// 获取最新的出入库信息
export function stockLogFindLastOne(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/findLastOne',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 应付列表查询
 * @apiUrl
 */
export function getPaymentList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/list',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 获取应收管理列表
 * @apiUrl
 */
export function getReceivableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/list',
    method: 'POST',
    data,
  })
}
// 校验应收记录批量调整有无审核中的数据
export function receivableFilterReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/filterReceivable',
    method: 'POST',
    data,
  })
}
// 批量收款新增
export function addRecordReceivableSignCheck(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/v2/add',
    method: 'post',
    data,
    signParams: ['sourceOrderId', 'sourceOrderType', 'totalAmount'],
  })
}
/**
 * @apiName 批量收款中根据customerId查询账户信息
 * @apiUrl
 */
export function getAccountDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/account/detail',
    method: 'POST',
    data,
  })
}
// 获取应收款项列表
export function getCollectionRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/batchSelect',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 收款单收款方式
 * @apiUrl
 */
export function getCollectionPayMethod(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/type',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量收款记录列表
 * @apiUrl
 */
export function getbatchCollectionRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/list',
    method: 'POST',
    data,
  })
}
// 订单退车结算信息
export function vehiclesettlement(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/settlementInfo',
    method: 'POST',
    data,
  })
}
// 个人租赁保存当前核算方案
export function addSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/addSettlement',
    method: 'POST',
    data,
  })
}
// 个人租赁订单确认并提交财务核算
export function confirmSettlement(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/confirmSettlement',
    method: 'POST',
    data,
  })
}
// 查询审批动态详情
export function approvalTaskDetail(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/detail',
    method: 'POST',
    data,
  })
}
// 根据退车交接时间 计算 到退车交接完成时间的应收金额 和 剩余租期的应收金额
export function calculateReceivableAmount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/calculateReceivableAmount',
    method: 'POST',
    data,
  })
}

// 取消退车预约单
export function cancelReturnCarBook(data = {}) {
  return request({
    url: '/admin/v1/vehicle/return/lease/cancelReturnCar',
    method: 'POST',
    data,
    bizCode: [35321],
  })
}
/* 客户还车相关接口 end */
/**
 * 判断是否有资金需要腿
 * @param {number} data.orderId 订单id
 * @returns data true表示有
 */
export function checkOrderNeedRefund(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/checkOrderNeedRefund',
    method: 'post',
    data,
  })
}
